const AboutUs = () => {
    return (<div>
        This was an application idea inspired by a group of friends after a long work day who just wanted a quick way of calculating what weights were set on each side of the barbell for quick lifts. 
        The next goal is to turn this into a mobile application as well as user login to keep track of individual goals.
    </div>)
}

export default AboutUs;